import { AxiosError } from "axios"
import { getReachSummary } from "../components/BenchmarkTemplateManager/service"
import { SummaryTableData } from "../components/SummaryTable/SummaryTable.domain"
import { useQuery } from "react-query"
import { BENCHMARK_PENETRATION_SUMMARY_QUERY } from "../constants"
import { PenetrationSummaryFilters } from "../interfaces"

export const useGetPenetrationSummary = (
	filtersBenchmark: PenetrationSummaryFilters,
	summaryPenetrationType: string
) => {
	const { data: reachData, isLoading, isError, error, refetch } = useQuery<
		SummaryTableData,
		AxiosError
	>(
		[
			BENCHMARK_PENETRATION_SUMMARY_QUERY,
			{ ...filtersBenchmark, metricName: summaryPenetrationType },
		],
		() =>
			getReachSummary({
				...filtersBenchmark,
				metricName: summaryPenetrationType,
			}),
		{
			retry: false,
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
		}
	)

	return { reachData, isLoading, isError, error, refetch }
}
